module.exports = __webpack_public_path__ + "img/acrylic_fr_fs.3bf0952e.png";